'use client'

import { ReactNode } from 'react'

import { FormMode } from 'shared/types/forms'
import { Modal, ModalTitle } from 'shared/ui/Modal'
import { KEYBOARD_KEYS } from 'shared/ui/types'
import { addTestId } from 'shared/utils/tests'

import { AddressServiceSingleton } from '../../mappers'
import { CustomerAddress } from '../../types'
import FormAddDeliveryAddress from '../FormAddDeliveryAddress'

import styles from './ModalAddDeliveryAddress.module.scss'

export interface ModalAddDeliveryAddressOptions {
  mode: FormMode
  isTrigger?: boolean
  trigger?: ReactNode
  address?: CustomerAddress
  isFirstAddressToAdd?: boolean
}

interface ModalAddDeliveryAddressProps extends ModalAddDeliveryAddressOptions {
  isOpen: boolean
  handleOpen: () => void
  handleClose: () => void
}

const ModalAddDeliveryAddress = ({
  mode,
  isOpen,
  handleOpen,
  handleClose,
  isTrigger = true,
  trigger,
  address,
  isFirstAddressToAdd = false
}: ModalAddDeliveryAddressProps) => {
  return (
    <>
      {isTrigger && (
        <div className={styles.triggerWrapper}
          onKeyDown={e => {
            if (e.key === KEYBOARD_KEYS.ENTER) {
              e.preventDefault()
              e.stopPropagation()
              void handleOpen()
            }
          }}
          onClick={e => {
            e.stopPropagation()
            void handleOpen()
          }}
          role='button'
          tabIndex={0}
          aria-label='Edytuj adres'
        >
          {trigger}
        </div>
      )}
      <Modal
        id={`${mode === FormMode.edit ? 'edit' : 'add'}-delivery-address-modal`}
        title={`${mode === FormMode.edit ? 'Edytuj' : 'Dodaj nowy'} adres`}
        open={isOpen}
        onClose={handleClose}
        size='large'
        {...addTestId('add-delivery-address-modal')}
      >
        <ModalTitle>{`${mode === FormMode.edit ? 'Edytuj' : 'Dodaj nowy'} adres`}</ModalTitle>
        <FormAddDeliveryAddress
          mode={mode}
          defaultValues={AddressServiceSingleton.mapDeliveryResponseToFormValues(
            address
          )}
          handleClose={handleClose}
          isFirstAddressToAdd={isFirstAddressToAdd}
        />
      </Modal>
    </>
  )
}

export default ModalAddDeliveryAddress
